import React, { useState } from "react"

import cn from "classnames"

import FilterCounter from "../FilterCounter/FilterCounter"
import arrowDropdown from "./arrowDropdown.svg"
import Separator from "~/components/Separator/Separator"
import { Body } from "~/components/ui"

import css from "./DropdownFilters.module.scss"

interface PropTypes {
  label: string
  children: React.ReactNode
  id: string
  count?: number
  display?: boolean
}

function DropdownFilters({
  label,
  children,
  id,
  count = 0,
  display = true,
}: PropTypes) {
  const [showChild, setshowChild] = useState(true)

  return display ? (
    <div className={css.dropdown} id={id}>
      <div className={cn(css.headerDropdown, { [css.closed]: !showChild })}>
        <div className={css.label}>
          <Body variant="body2" bold>
            {label}
          </Body>
          {count > 0 && <FilterCounter count={count} />}
        </div>
        <img
          src={arrowDropdown}
          alt="back"
          onClick={() => setshowChild(!showChild)}
          className={cn(css.icon, { [css.iconDesactive]: showChild })}
        />
      </div>
      <div className={!showChild ? css.hideChild : undefined}>{children}</div>
      <Separator />
    </div>
  ) : null
}

export default DropdownFilters
